import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  data() {
    return {
      search: '',
    };
  },
  computed: {
    ...mapState('organizations', ['organizations', 'organization']),
    /**
     * Computed property for the name vuex property
     */
    localOrganization: {
      get() {
        return this.organization;
      },
      set(newValue) {
        this.SET_organization(newValue);
      },
    },
  },
  methods: {
    ...mapActions('organizations', ['LOAD_organizations', 'SET_organization']),
    ...mapMutations('organizations', ['SET_organization']),
    async organizationChanged(org) {
      this.$log.info('organization changed', org);
      this.SET_organization(org);
      this.$root.$emit('organization.changed', org);
      // this.$root.$abortAxios();
      if (this.$route.name !== 'app-Home') {
        await this.$router.push({ name: 'app-Home' });
      }
      window.location.reload();
    },
    async loadOrganizations() {
      try {
        this.isLoading = true;
        await this.LOAD_organizations();
        this.$nextTick(() => {
          this.localOrganization = this.organization;
          this.$root.$emit('organizations.loaded', this.organizations);
        });
      } catch (error) {
        this.$log.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.$root.$on('auth:login', async () => {
      await this.loadOrganizations();
    });
  },
  async mounted() {
    await this.loadOrganizations();
  },
};
